// src/components/SocialLinks/SocialLinks.jsx
import React from 'react';
import { useTooltip } from '@app/providers';
import './SocialLinks.css';

const SocialLinks = () => {
  const { showTooltip, hideTooltip } = useTooltip();

  const socialLinks = [
    {
      id: 'youtube',
      url: 'https://www.youtube.com/channel/UCfnT--3pJC2B-xA6kPlcJ2Q',
      name: 'YOUTUBE',
      title: '📺 YOUTUBE',
      description: 'Видео-гайды и стримы по играм',
      detail: 'Подписывайтесь, чтобы не пропустить новые видео!',
      icon: (
        <svg viewBox="0 0 24 24" fill="currentColor">
          <path d="M23.498 6.186a3.016 3.016 0 0 0-2.122-2.136C19.505 3.545 12 3.545 12 3.545s-7.505 0-9.377.505A3.017 3.017 0 0 0 .502 6.186C0 8.07 0 12 0 12s0 3.93.502 5.814a3.016 3.016 0 0 0 2.122 2.136c1.871.505 9.376.505 9.376.505s7.505 0 9.377-.505a3.015 3.015 0 0 0 2.122-2.136C24 15.93 24 12 24 12s0-3.93-.502-5.814zM9.545 15.568V8.432L15.818 12l-6.273 3.568z"/>
        </svg>
      ),
    },
    {
      id: 'twitch',
      url: 'https://www.twitch.tv/myugc',
      name: 'TWITCH',
      title: '🎮 TWITCH',
      description: 'Прямые эфиры и общение с комьюнити',
      detail: 'Присоединяйтесь к стримам и чату!',
      icon: (
        <svg viewBox="0 0 24 24" fill="currentColor">
          <path d="M11.571 4.714h1.715v5.143H11.57zm4.715 0H18v5.143h-1.714zM6 0L1.714 4.286v15.428h5.143V24l4.286-4.286h3.428L22.286 12V0zm14.571 11.143l-3.428 3.428h-3.429l-3 3v-3H6.857V1.714h13.714z"/>
        </svg>
      ),
    },
    {
      id: 'github',
      url: 'https://github.com/leonhadouken/MyUGC',
      name: 'GITHUB',
      title: '🐙 GITHUB',
      description: 'Роадмап и витрина',
      detail: 'Участвуйте в разработке или просто поставьте звезду',
      icon: (
        <svg viewBox="0 0 24 24" fill="currentColor">
          <path d="M12 2C6.48 2 2 6.48 2 12c0 4.42 2.87 8.17 6.84 9.49.5.09.68-.21.68-.48 0-.24-.01-.88-.01-1.73-2.78.6-3.37-1.34-3.37-1.34-.45-1.15-1.11-1.46-1.11-1.46-.91-.62.07-.61.07-.61 1 .07 1.53 1.03 1.53 1.03.89 1.52 2.34 1.08 2.91.83.09-.65.35-1.09.63-1.34-2.22-.25-4.55-1.11-4.55-4.94 0-1.09.39-1.98 1.03-2.68-.1-.25-.45-1.26.1-2.62 0 0 .84-.27 2.75 1.02.8-.22 1.65-.33 2.5-.33.85 0 1.7.11 2.5.33 1.91-1.29 2.75-1.02 2.75-1.02.55 1.36.2 2.37.1 2.62.64.7 1.03 1.59 1.03 2.68 0 3.84-2.34 4.68-4.57 4.93.36.31.68.92.68 1.85 0 1.34-.01 2.42-.01 2.75 0 .27.18.58.69.48C19.13 20.17 22 16.42 22 12c0-5.52-4.48-10-10-10z"/>
        </svg>
      ),
    },
    {
      id: 'vk',
      url: 'https://vk.com/game_challenge',
      name: 'VKONTAKTE',
      title: '💬 VKONTAKTE',
      description: 'Новости, анонсы и обсуждения',
      detail: 'Будьте в курсе всех новостей проекта',
      icon: (
        <svg viewBox="0 0 24 24" fill="currentColor">
          <path d="M15.684 0H8.316C2.825 0 0 2.825 0 8.316v7.368C0 21.175 2.825 24 8.316 24h7.368c5.491 0 8.316-2.825 8.316-8.316V8.316C24 2.825 21.175 0 15.684 0zm3.519 16.842h-1.846c-.684 0-.895-.526-1.474-1.122-.526-.562-1.052-1.018-1.614-1.018-.597 0-.807.457-.807 1.158v1.018c0 .421-.158.684-.912.684-1.333 0-2.825-.807-3.912-2.298-1.456-1.649-2.193-3.509-2.193-3.842 0-.175.07-.333.246-.333h1.842c.404 0 .526.246.667.579.597 1.246 1.333 2.473 2.175 3.193.175.158.333.246.491.246.263 0 .333-.158.333-.509v-1.877c0-.983-.491-1.052-.491-1.403 0-.175.123-.263.246-.263h2.421c.333 0 .491.175.491.491v2.578c0 .246.158.333.333.333.246 0 .491-.123.702-.333.842-.842 1.526-2.158 1.526-2.158.07-.175.175-.333.404-.333.175 0 .263.07.333.175 0 0 .983 1.649 1.333 2.263.018.07.07.123.07.158.07.158.07.316.07.474 0 .333-.246.526-.491.649-.526.263-.93.491-.93.93 0 .211.07.316.158.404.158.175.474.526.667.772.246.263.491.544.649.772.175.246.263.491.263.772 0 .351-.175.491-.491.491z"/>
        </svg>
      ),
    },
    {
      id: 'discord',
      url: 'https://discord.gg/aFdhHDHreh',
      name: 'DISCORD',
      title: '🎧 DISCORD',
      description: 'Сервер комьюнити, помощь и чат',
      detail: 'Общайтесь с другими игроками в реальном времени',
      icon: (
        <svg viewBox="0 0 24 24" fill="currentColor">
          <path d="M20.317 4.37a19.791 19.791 0 0 0-4.885-1.515c-.21.385-.454.9-.62 1.307a18.23 18.23 0 0 0-5.43 0 12.505 12.505 0 0 0-.63-1.307 19.752 19.752 0 0 0-4.885 1.515c-2.78 4.087-3.532 8.366-3.137 12.349a19.89 19.89 0 0 0 6.016 2.93c.488-.664.92-1.37 1.291-2.112a12.23 12.23 0 0 1-2.033-.978c.171-.124.338-.256.5-.393a14.243 14.243 0 0 0 8.498 0c.162.137.329.27.5.393-.645.39-1.324.723-2.033.978.371.742.803 1.448 1.291 2.112a19.83 19.83 0 0 0 6.016-2.93c.458-4.752-.602-8.993-3.137-12.349zM8.02 14.63c-1.183 0-2.157-1.07-2.157-2.38 0-1.31.944-2.38 2.157-2.38 1.213 0 2.187 1.07 2.157 2.38 0 1.31-.944 2.38-2.157 2.38zm7.975 0c-1.183 0-2.157-1.07-2.157-2.38 0-1.31.944-2.38 2.157-2.38 1.213 0 2.187 1.07 2.157 2.38 0 1.31-.944 2.38-2.157 2.38z"/>
        </svg>
      ),
    }
  ];

  const handleIconHover = (link) => {
    showTooltip(
      link.title || link.name,
      link.description,
      link.detail
    );
  };

  return (
    <div className="social-links">
      {socialLinks.map((link) => (
        <a
          key={link.id}
          href={link.url}
          target="_blank"
          rel="noopener noreferrer"
          className={`social-link ${link.id}`}
          onMouseEnter={() => handleIconHover(link)}
          onMouseLeave={hideTooltip}
        >
          <span className="social-icon">
            {link.icon}
          </span>
        </a>
      ))}
    </div>
  );
};

export default SocialLinks;